import { render } from "./CollapseCard.vue?vue&type=template&id=2bc06294"
import script from "./CollapseCard.vue?vue&type=script&lang=js"
export * from "./CollapseCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/CollapseCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bc06294"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bc06294', __exports__)) {
    api.reload('2bc06294', __exports__)
  }
  
  module.hot.accept("./CollapseCard.vue?vue&type=template&id=2bc06294", () => {
    api.rerender('2bc06294', render)
  })

}


export default __exports__